import styled from 'styled-components'

export const TextContentWrapper = styled.div<{
  $isHeader?: boolean
  $isActive?: boolean
}>`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const NameWrapper = styled.div`
  display: flex;
  gap: 4px;
`
